import React from "react";
import { Box, useTheme } from "@mui/material";

/**
 * Ambient 3px Top Progress Bar
 * Uses modern CSS Scroll-Driven Animations (@supports (animation-timeline: scroll()))
 * with smooth fallback via scrollPercent.
 */
const ChapterTopProgressBar = ({ scrollPercent = 0, visible = true }) => {
  const theme = useTheme();

  if (!visible) return null;

  const primaryColor = theme.palette.primary.main;
  const lightColor = theme.palette.primary.light || primaryColor;

  return (
    <Box
      aria-hidden="true"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "3px",
        zIndex: 1400,
        pointerEvents: "none",
        bgcolor: "transparent",
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: "100%",
          transformOrigin: "0% 50%",
          background: `linear-gradient(90deg, ${primaryColor} 0%, ${lightColor} 100%)`,
          boxShadow: `0 0 8px ${primaryColor}, 0 0 2px ${lightColor}`,
          borderTopRightRadius: 2,
          borderBottomRightRadius: 2,
          transition: "transform 100ms ease-out",
          // Fallback transform
          transform: `scaleX(${scrollPercent / 100})`,
          // Native CSS Scroll-driven animation when available
          "@media (prefers-reduced-motion: no-preference)": {
            "@supports (animation-timeline: scroll())": {
              transformOrigin: "0% 50%",
              animation: "grow-reading-progress auto linear",
              animationTimeline: "scroll()",
            },
          },
          "@keyframes grow-reading-progress": {
            from: { transform: "scaleX(0)" },
            to: { transform: "scaleX(1)" },
          },
        }}
      />
    </Box>
  );
};

export default ChapterTopProgressBar;
